import { GameData } from './GameSlide.types';
import steamLogoBasic from '../../assets/steam_logo_basic.png';
import steamLogoHover from '../../assets/steam_logo_hover.png';

export const GAMES_DATA: readonly GameData[] = [
  {
    id: 'caterva',
    name: 'Caterva',
    titleKey: 'games.caterva.title',
    imageEN: '/src/assets/CATERVA_OD.jpg',
    imageES: '/src/assets/CATERVA_OD.jpg',
    steamUrl: 'https://s.team/a/5012060',
    buttonTextKey: 'games.caterva.buttonText',
  },
  {
    id: 'sanmartin',
    name: 'San Martin',
    titleKey: 'games.sanmartin.title',
    imageEN: '/src/assets/SanMartin_ENG.webp',
    imageES: '/src/assets/SanMartin_ES.webp',
    steamUrl: 'https://s.team/a/5023240',
    buttonTextKey: 'games.sanmartin.buttonText',
  },
] as const;

export const STEAM_LOGO_BASIC = steamLogoBasic;
export const STEAM_LOGO_HOVER = steamLogoHover;

export const GAMESLIDE_CONFIG = {
  AUTOPLAY_SPEED: 4000,
  FADE_EFFECT: true,
  DOTS_VISIBLE: true,
  ARROWS_VISIBLE: true,
  SWIPE_ENABLED: true,
} as const;

export const GAMESLIDE_ACCESSIBILITY = {
  SLIDE_REGION: 'region',
  GAME_IMAGE_ROLE: 'img',
  STEAM_BUTTON_ROLE: 'link',
  CAROUSEL_NAVIGATION: 'carousel navigation',
  SLIDE_LABEL: 'Game slide',
  PREVIOUS_SLIDE: 'Previous game',
  NEXT_SLIDE: 'Next game',
} as const;

export const GAMESLIDE_CLASSES = {
  CONTAINER: 'gameslide-container',
  SLIDE: 'gameslide-slide',
  IMAGE_WRAPPER: 'gameslide-image-wrapper',
  IMAGE: 'gameslide-image',
  CONTENT: 'gameslide-content',
  BUTTON: 'gameslide-steam-button',
  GRADIENT: 'gameslide-gradient',
} as const;
